import { render, staticRenderFns } from "./DetalheFaturamentoPrincipaisCliente3.vue?vue&type=template&id=3cb8ee5b&scoped=true&"
import script from "./DetalheFaturamentoPrincipaisCliente3.vue?vue&type=script&lang=js&"
export * from "./DetalheFaturamentoPrincipaisCliente3.vue?vue&type=script&lang=js&"
import style0 from "./DetalheFaturamentoPrincipaisCliente3.vue?vue&type=style&index=0&id=3cb8ee5b&scoped=true&lang=css&"
import style1 from "./DetalheFaturamentoPrincipaisCliente3.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb8ee5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VIcon,VRow,VTooltip})
